export const media = {
  logos: {
    casaDeFe: "/assets/logos/casa-de-fe.png",
    igleKids: "/assets/logos/igle-kids.png"
  },
  textosBiblicos: [
    { id: 1, texto: "Instruye al niño en su camino, y aun cuando fuere viejo no se apartará de él.", cita: "Proverbios 22:6" },
    { id: 2, texto: "Dejad a los niños venir a mí, y no se lo impidáis.", cita: "Mateo 19:14" },
    { id: 3, texto: "Y todos tus hijos serán enseñados por Jehová.", cita: "Isaías 54:13" }
  ]
};